
import { ref, readonly } from 'vue';
import HTTP from '@/utils/http';
import { useCsrf } from '@/composables/integrations/slack/useCsrf';

export function useGenerateAuthUrl() {
  const csrf = useCsrf();
  const isGenerating = ref(false);

  async function generate() {
    try {
      isGenerating.value = true;
      csrf.remove();

      const response = await HTTP({
        url: 'integrations/slack',
        method: 'post',
        suppressAllErrors: true,
      });

      csrf.set(response.data.csrf);

      return {
        redirectUrl: response.data.redirect_url,
        csrf: response.data.csrf,
      };
    } catch (err) {
      // TODO: improve handling

      throw err;
    } finally {
      isGenerating.value = false;
    }
  }

  return {
    isGenerating: readonly(isGenerating),
    generate,
  };
}
